import { PREVIEW_NS, type PreviewImageMessage } from "@innoclouds/ui";
import { faceSourceOf } from "../utils/fonts/faces";
import { withoutHighlight } from "./appearance";

const unquote = (family: string) => family.replace(/^["']|["']$/g, "");

const loadedFaces = () =>
	[...document.fonts].flatMap((face) => {
		const src = faceSourceOf(face);
		return src && face.status === "loaded" ? [{ family: unquote(face.family), src, weight: face.weight, style: face.style }] : [];
	});

// clip: "viewport" у snapdom теряет fixed-слои (баннер) и сдвигает остальное, поэтому снимаем документ целиком
// и вырезаем видимую часть сами — тогда пиксели совпадают с координатами из describe
const cropToViewport = async (image: Blob, root: DOMRect) => {
	const x = Math.round(-root.left);
	const y = Math.round(-root.top);
	const width = window.innerWidth;
	const height = window.innerHeight;
	const bitmap = await createImageBitmap(image);
	if (x === 0 && y === 0 && bitmap.width === width && bitmap.height === height) return image;
	const canvas = document.createElement("canvas");
	canvas.width = width;
	canvas.height = height;
	canvas.getContext("2d")?.drawImage(bitmap, -x, -y);
	return new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/png"));
};

export const capture = async (id: number): Promise<PreviewImageMessage> => {
	const width = window.innerWidth;
	const height = window.innerHeight;
	try {
		const { snapdom } = await import("@zumer/snapdom");
		const root = document.documentElement;
		const rect = root.getBoundingClientRect();
		const page = await withoutHighlight(() => snapdom.toBlob(root, { dpr: 1, scale: 1, format: "png", localFonts: loadedFaces(), invalidate: true }));
		const image = await cropToViewport(page, rect);
		return { ns: PREVIEW_NS, type: "image", id, status: image ? "ok" : "error", image, width, height };
	} catch {
		return { ns: PREVIEW_NS, type: "image", id, status: "error", image: null, width, height };
	}
};
